import React, { Fragment, useLayoutEffect, useRef, useState } from 'react';
import { interpolate } from '@popmotion/popcorn';
import { useMeasure } from '../../hooks';
import { supportsPassiveEvents } from '../../utils';
var getLeftScrollShadow = interpolate([0, 0.2], [0, 1]);
var getRightScrollShadow = interpolate([0.8, 1], [1, 0]);
var listenerOptions = supportsPassiveEvents ? {
  capture: true,
  passive: false
} : true;
var shadowStyle = {
  width: 10,
  position: 'absolute',
  top: 0,
  bottom: 0,
  zIndex: 30,
  pointerEvents: 'none'
};

function getProgress(offset, maxOffset) {
  return !offset || !maxOffset ? 0 : offset / maxOffset;
}

function getBackground(direction) {
  var rotate = 90 * direction;
  return "linear-gradient(" + rotate + "deg, transparent 4px, rgba(125, 125, 125, 0.15))";
}

function setShadowStyles(_ref) {
  var leftNode = _ref.leftNode,
      rightNode = _ref.rightNode,
      offset = _ref.offset,
      progress = _ref.progress;
  leftNode.style.left = offset + 'px';
  leftNode.style.background = getBackground(-1);
  leftNode.style.opacity = getLeftScrollShadow(progress);
  rightNode.style.right = offset + 'px';
  rightNode.style.background = getBackground(1);
  rightNode.style.opacity = getRightScrollShadow(progress);
}

function useScrollShadows(ref) {
  var leftShadow = useRef();
  var rightShadow = useRef();

  var _useState = useState(false),
      canScroll = _useState[0],
      setCanScroll = _useState[1];

  var _useState2 = useState(null),
      maxOffset = _useState2[0],
      setMaxOffset = _useState2[1];

  var _useMeasure = useMeasure(),
      useMeasureRef = _useMeasure[0],
      useMeasureEffect = _useMeasure[1];

  useMeasureRef(ref);
  useMeasureEffect(function (_ref2) {
    var node = _ref2[0];
    setCanScroll(node.scrollWidth > node.offsetWidth);
    setMaxOffset(node.scrollWidth - node.offsetWidth);
  }, []);
  useLayoutEffect(function () {
    if (leftShadow.current && rightShadow.current) {
      var handleScroll = function handleScroll() {
        setShadowStyles({
          leftNode: leftShadow.current,
          rightNode: rightShadow.current,
          progress: getProgress(node.scrollLeft, maxOffset),
          offset: 0
        });
      };

      var node = ref.current;
      handleScroll();
      node.addEventListener('scroll', handleScroll, listenerOptions);
      return function () {
        node.removeEventListener('scroll', handleScroll, listenerOptions);
      };
    }
  }, [maxOffset]);
  return canScroll && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: leftShadow,
    style: shadowStyle,
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement("div", {
    ref: rightShadow,
    style: shadowStyle,
    "aria-hidden": true
  }));
}

export default useScrollShadows;